module.exports = __webpack_public_path__ + "media/images/cars_diagram_logo-39ed9f470e6bf35704ef03ee41e9db0c.svg";